export enum StatusGeolocalizacao {
    Realizado = 0,
    Proximo = 1,
    NaoRealizado = 2
}